import { TStockItem } from 'api/stock/stock.types';
import { TPhoneCasesAvailability } from 'screens/ProductPage/ProductPage.types';

export const checkCartStockFulfillment = (
  cartItemsStock: Record<TStockItem['id'], number>,
  stockItemsVocabulary: Record<TStockItem['id'], TStockItem>
): boolean => {
  for (const idKey in cartItemsStock) {
    const cartItemStock = cartItemsStock[idKey];
    const stockItemVocabulary = stockItemsVocabulary[idKey]?.quantity;
    if (cartItemStock > stockItemVocabulary) {
      return false;
    }
  }
  return true;
};

export const getMissingStockItems = (
  cartItemsStock: Record<TStockItem['id'], number>,
  stockItemsVocabulary: Record<TStockItem['id'], TStockItem>
): Record<TStockItem['id'], TStockItem> =>
  Object.entries(cartItemsStock).reduce<Record<TStockItem['id'], TStockItem>>(
    (acc, [id, requiredQty]) => {
      if (requiredQty > stockItemsVocabulary[id]?.quantity) {
        acc[id] = stockItemsVocabulary[id];
      }
      return acc;
    },
    {}
  );

export const hasMissingStockItems = (
  cartItemStock: Array<{ stockItem: TStockItem; quantity: number }>,
  stockItemsMissingVocabulary: Record<TStockItem['id'], TStockItem>
): boolean => {
  for (const stockItem of cartItemStock) {
    const hasMissingStockItem =
      !!stockItemsMissingVocabulary[stockItem.stockItem?.id];
    if (hasMissingStockItem) {
      return true;
    }
  }
  return false;
};

export const hasMissingVariation = (
  phoneCasesAvailability: TPhoneCasesAvailability,
  selectedPhoneModel: string,
  variationName: string
) => {
  return !phoneCasesAvailability?.variationsStock?.[selectedPhoneModel]?.[
    variationName
  ]?.quantity;
};
